var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',{staticClass:"pa-0",attrs:{"no-gutters":""}},[_c('v-col',{attrs:{"cols":"12","sm":"12","md":"12","xs":"12","lg":"12","xl":"12"}},[_c('CardTypeCRUD')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }